import { PayoutValues } from '@/components/Admin/Prompt/PayoutForm';
import apiClient from './_axios';
import { handleAxiosError } from '@/utils/handleAxiosError';

export const createPayout = async (data: PayoutValues) => {
   try {
      const response = await apiClient.post(`/payout/create-payout`, data);
      return {
         status: response.status,
         data: response.data,
      };
   } catch (err: unknown) {
      const axiosErr = handleAxiosError(err);

      if (axiosErr) {
         if (axiosErr.status === 402) {
            throw {
               status: 402,
               message: 'Insufficient funds for withdrawal',
            };
         } else if (axiosErr.status === 400) {
            throw {
               status: 400,
               message: axiosErr.message || 'Invalid payout request',
            };
         } else {
            throw {
               status: axiosErr.status || 500,
               message: axiosErr.message || 'Failed to process payout request',
            };
         }
      }
      throw {
         status: 500,
         message: 'An unexpected error occurred',
      };
   }
};

export const fetchPayout = async () => {
   try {
      const response = await apiClient.get('/payout');
      return {
         status: response.status,
         data: response.data,
      };
   } catch (err: unknown) {
      const axiosErr = handleAxiosError(err);
      if (axiosErr) {
         throw {
            status: axiosErr.status || 500,
            message: axiosErr.message || 'Failed to process payout request',
         };
      }
   }
};

export const getPayoutReceived = async () => {
   try {
      const response = await apiClient.get('/payout/payout-received');
      // console.log(response);
      return response.data;
   } catch (err: unknown) {
      const axiosErr = handleAxiosError(err);
      if (axiosErr) {
         throw {
            status: axiosErr.status || 500,
            message: axiosErr.message || 'Failed to process payout received',
         };
      }
   }
};
export const getPayoutAvailable = async () => {
   try {
      const response = await apiClient.get('/payout/payout-available');
      // console.log(response);
      return response.data;
   } catch (err: unknown) {
      const axiosErr = handleAxiosError(err);
      if (axiosErr) {
         throw {
            status: axiosErr.status || 500,
            message: axiosErr.message || 'Failed to process payout received',
         };
      }
   }
};
